import { getHours } from 'date-fns';
import { useSession } from 'next-auth/react';

import { Heading } from '@/components/heading';
import { Text } from '@/components/text';
import { formatIsoDate } from '@/utils/format/date-time';

const getWelcomeMessage = (name: string | null | undefined, date: Date) => {
  const hour = getHours(date);

  const timeGreetings = {
    morning: [`Good morning, ${name}`],
    day: [`Good day, ${name}!`, `Greetings, ${name}`, `Good afternoon, ${name}`, `Hey ${name}`],
    evening: [`Good evening, ${name}`, `Evening, ${name}!`],
    night: [`Good evening, ${name}`, `Up late tonight, ${name}? 🌙`],
  };

  let period: keyof typeof timeGreetings;
  if (hour >= 5 && hour < 12) period = 'morning';
  else if (hour >= 12 && hour < 18) period = 'day';
  else if (hour >= 18 && hour < 22) period = 'evening';
  else period = 'night';

  const greetings = timeGreetings[period];
  return greetings[Math.floor(Math.random() * greetings.length)];
};

const DashboardWelcome = () => {
  const { data: session } = useSession();

  const now = new Date();

  return (
    <div className="px-2 pt-2 md:px-0 md:pt-0">
      <Text className="mb-0 text-baseSm text-grey-600">{formatIsoDate(now, 'EEEE, MMMM dd yyyy')}</Text>
      <Heading variant="h3" as="h1">
        {getWelcomeMessage(session?.user?.name, now)}
      </Heading>
    </div>
  );
};

export { DashboardWelcome };
